const config = {
	api: import.meta.env.VITE_API_URL,
};

export default config;